import React, { ReactNode } from 'react';
import { AlignLeftOutlined, PlayCircleOutlined, FunctionOutlined } from '@ant-design/icons';
import { Footer, Row, Button } from '../../../../styles/common';
import arrowSendContext from 'img/arrow-send-context.svg';
import { MESSAGES, MIN_CHARACTERS } from '../../utils/constants';

interface SubmitFooterProps {
  BackButton?: ReactNode;
  onSubmit: () => void;
  isSubmitting: boolean;
  answerLength: number;
  hasCommentedQuestion?: boolean;
  hasVideoEmbed?: boolean;
  hasFormula?: boolean;
  onReadResolution?: () => void;
  onWatchResolution?: () => void;
  onShowFormula?: () => void;
}

export const SubmitFooter: React.FC<SubmitFooterProps> = ({
  BackButton,
  onSubmit,
  isSubmitting,
  answerLength,
  hasCommentedQuestion,
  hasVideoEmbed,
  hasFormula,
  onReadResolution,
  onWatchResolution,
  onShowFormula,
}) => {
  return (
    <Footer>
      <Row width="100%" maxWidthTransformCol="1040px">
        {BackButton && BackButton}
        <Row maxWidthTransformCol="1040px">
          {hasCommentedQuestion && onReadResolution && (
            <Button
              styles="secondary"
              onClick={onReadResolution}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <AlignLeftOutlined /> Ler Resolução
            </Button>
          )}
          {hasVideoEmbed && onWatchResolution && (
            <Button
              styles="secondary"
              onClick={onWatchResolution}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <PlayCircleOutlined /> Assistir Resolução
            </Button>
          )}
          {hasFormula && onShowFormula && (
            <Button
              styles="secondary"
              onClick={onShowFormula}
              margin="0 0 0 16px"
              maxWidthTransformCol="1040px"
            >
              <FunctionOutlined /> Fórmula
            </Button>
          )}
        </Row>
        <Button
          onClick={onSubmit}
          disabled={isSubmitting || answerLength < MIN_CHARACTERS}
          styles="primary"
          marginImage="0 4px 0 0"
          margin="0 0 0 auto"
        >
          {isSubmitting ? (
            MESSAGES.SUBMITTING
          ) : (
            <>
              {MESSAGES.SUBMIT_BUTTON} <img src={arrowSendContext} alt="Enviar" />
            </>
          )}
        </Button>
      </Row>
    </Footer>
  );
};
